import { useEffect, useState } from "react";
import { Client, Company, Quote } from "../../types";
import Api from "../../Api";
import DiscreetMessage from "../../parts/DiscreetMessage";
import ContentRentStart from "./ContentRentStart";
import ContentRentUpdate from "./ContentRentUpdate";
import classNames from "classnames";

type Mode = "start" | "update";

const ContentRent = ({ uuid }: { uuid: string }) => {
  const [quote, setQuote] = useState<Quote | null>(null);
  const [equipmentMap, setEquipmentMap] = useState<Record<
    string,
    string
  > | null>(null);
  const [client, setClient] = useState<Client | null>(null);
  const [company, setCompany] = useState<Company | null>(null);

  const [mode, setMode] = useState<Mode>("start");

  useEffect(() => {
    Api.contractsRender(uuid).then(
      ({ quote, client, company, equipmentMap }) => {
        setQuote(quote);
        setEquipmentMap(equipmentMap);
        setClient(client);
        setCompany(company);

        document.title = `Contrato de locação ${quote.number} - ${client.name}`;
      }
    );
  }, [uuid]);

  if (
    quote === null ||
    client === null ||
    company === null ||
    equipmentMap === null
  )
    return <DiscreetMessage text="Carregando" />;

  return (
    <div>
      <Switcher mode={mode} setMode={setMode} />

      {mode === "start" ? (
        <ContentRentStart
          company={company}
          client={client}
          quote={quote}
          equipmentMap={equipmentMap}
        />
      ) : (
        <ContentRentUpdate
          company={company}
          client={client}
          quote={quote}
          equipmentMap={equipmentMap}
        />
      )}
    </div>
  );
};

export default ContentRent;

const Switcher = ({
  mode,
  setMode,
}: {
  mode: Mode;
  setMode: (mode: Mode) => void;
}) => {
  return (
    <div className="fixed bottom-0 left-0 right-0 flex justify-center print:hidden">
      <div className="bg-white py-4 px-5 border-2 shadow-lg border-gray-900 mb-8 rounded-full">
        <button
          className={classNames(
            "border rounded-l-full py-2 px-6 font-bold text-sm",
            {
              "bg-sky-500 border-sky-900 text-white border-r-0 hover:bg-sky-400":
                mode === "start",
              "bg-gray-100 border-gray-700 text-gray-700 hover:bg-gray-50":
                mode === "update",
            }
          )}
          onClick={() => setMode("start")}
        >
          Novo contrato
        </button>
        <button
          className={classNames(
            "border rounded-r-full py-2 px-6 font-bold text-sm",
            {
              "bg-sky-500 border-sky-900 text-white border-l-0 hover:bg-sky-400":
                mode === "update",
              "bg-gray-100 border-gray-700 text-gray-700 hover:bg-gray-50":
                mode === "start",
            }
          )}
          onClick={() => setMode("update")}
        >
          Termo aditivo
        </button>
      </div>
    </div>
  );
};
